import {defaultState} from './state';
import * as IntentsActions from '../actions/IntentsActions';

const location = (state = defaultState.location, action) => {

    switch (action.type) {
        case IntentsActions.GOT_IP_ACTION.name:
            return {
                ...state,
                ip: action.ip
            };
        case IntentsActions.GOT_GEOLOCATION_SUCCESS_ACTION.name:
            return {
                ...state,
                geo: action.coords.coords ? `${action.coords.coords.latitude},${action.coords.coords.longitude}` : null,
            };
        default:
            return state;
    }
};

export default location;